import { FC, useEffect, useState } from 'react';

import { useQuery } from '@apollo/client';
import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { createPortal } from 'react-dom';

import { DEFAULT_GROUP_COLOR } from 'consts';

import { parseMapDragId } from '../../dragIds';
import s from './DraggableOverlay.module.scss';
import {
  HOST,
  HOST_GROUP,
  IHostGroupRequest,
  IHostGroupResponse,
  IHostRequest,
  IHostResponse,
} from './schema';

export const DraggableOverlay: FC = () => {
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  const { active } = useDndContext();
  const activeEntity = parseMapDragId(active?.id);

  const { data: hostResponse } = useQuery<IHostResponse, IHostRequest>(HOST, {
    fetchPolicy: 'cache-only',
    variables: { id: activeEntity?.id ?? 0 },
    skip: activeEntity?.kind !== 'host',
  });
  const { data: groupResponse } = useQuery<
    IHostGroupResponse,
    IHostGroupRequest
  >(HOST_GROUP, {
    fetchPolicy: 'cache-only',
    variables: { id: hostResponse?.hostOverview.group_id ?? 0 },
    skip: activeEntity?.kind !== 'host' || !hostResponse?.hostOverview,
  });

  useEffect(() => {
    const newNode = document.createElement('div');

    document.body.appendChild(newNode);
    setNode(newNode);

    return () => {
      document.body.removeChild(newNode);
    };
  }, []);

  if (!node) return null;

  return createPortal(
    <DragOverlay>
      {activeEntity?.kind === 'host' ? (
        <div className={s.container}>
          <div className={s.top}>
            {hostResponse?.hostOverview.position}
            <div
              style={{
                backgroundColor:
                  groupResponse?.hostGroupOverview.customization?.color ||
                  DEFAULT_GROUP_COLOR,
              }}
              className={s.groupColor}
            />
          </div>
          {groupResponse?.hostGroupOverview.title}
        </div>
      ) : null}
    </DragOverlay>,
    node
  );
};
